import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDialog } from "../../../../../../../hooks";
import useRootTranslation from "../../../../../../../hooks/use-root-translation";
import { AppState } from "../../../../../../../store/app-state";
import { invalidateInvite } from "../../../../../../../store/company-profile/company-profile.actions";
import { RemoveButton, TRow, Table } from "./group-table.styled";
import { format, toDate } from "date-fns";
import { getLocale } from "../../../../../../../utils/redux/date";

const InvitesTable: React.FC = () => {
  const dispatch = useDispatch();
  const { createDialog } = useDialog();
  const { root } = useRootTranslation(
    "company-profile.group-section.invite-table-headers",
    "private-home-page"
  );
  const { user } = useSelector((state: AppState) => state.authState);
  const { invites } = useSelector(
    (state: AppState) => state.companyProfileState
  );

  const confirmInvalidateInvite = useCallback(() => {
    return createDialog({
      title: root("confirm-dialog.title"),
      message: root("confirm-dialog.message"),
      confirmLabel: root("confirm-dialog.confirmLabel"),
      top: 0,
    });
  }, [root, createDialog]);

  const handleInvalidateInvite = useCallback(
    async (key: string) => {
      const confirmed = await confirmInvalidateInvite();
      if (confirmed && user?.corporate.id) {
        dispatch(invalidateInvite(key, user.corporate.id));
      }
    },
    [dispatch, confirmInvalidateInvite, user]
  );

  return (
    <Table>
      <TRow>
        <th>{root("email")}</th>
        <th>{root("created")}</th>
        <th className="center">{root("action")}</th>
      </TRow>
      {invites.data?.map((invite, index) => (
        <TRow>
          <td>{invite.email}</td>
          <td>
            {format(toDate(Date.parse(invite.created)), "dd/MM/yyyy", {
              locale: getLocale(),
            })}
          </td>
          <td className="center">
            <RemoveButton
              onClick={() => handleInvalidateInvite(invite.cache_key)}
            >
              {root("cancel-invite")}
            </RemoveButton>
          </td>
        </TRow>
      ))}
    </Table>
  );
};

export default InvitesTable;
